import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  UncontrolledTooltip,
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row
} from 'reactstrap'

import CustomPagination from 'components/Pagination'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import PageTitle from 'components/Title/PageTitle'
import Moment from 'moment'
import SearchForm from 'components/SearchForm'

import StagesHOC from './actions'
import StagesForm from './Form'

import Lang from 'Lang/General'

const Stages = props => {

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeStagesHOC('subscribedPackage', tmpIndex > -1)
  }, [])

  useEffect(() => {
    props.getStages({
      filter: { "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id },
      page: 1,
      is_paginated: true,
    })
    props.onChangeStagesHOC('defaultQuery', {
      filter: { "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id },
      page: 1,
      is_paginated: true,
    })
    props.getFairs()
  }, [])

  useEffect(() => {
    let temp = _.cloneDeep(props.searchParams)
    temp[0]['options'] = props.fairs

    props.onChangeStagesHOC('searchParams', temp)
  }, [props.fairs])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangeStagesHOC('selectedStages', {})
    }
  }, [props.showEditModal])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderCreateStagesForm = () => (
    <Modal isOpen={props.showCreateStages} size='xl' >
      <StagesForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        data={props.data}
        fairs={props.fairs}
        mode={'create'}
        onSubmit={props.createStages}
        onClose={() => props.onChangeStagesHOC('showCreateStages', false)}
      />
      {props.onLoadStagesHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderUpdateStagesForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <StagesForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        mode={'edit'}
        fairs={props.fairs}
        selectedStages={props.selectedStages}
        data={props.data}
        onSubmit={props.updateStages}
        onClose={() => props.onChangeStagesHOC('showEditModal', false)}
      />
      {props.onLoadStagesHOC && <LoadingOverlay />}
    </Modal>
  )

  return (
    <>
      <PageTitle
        heading={Lang['STAGES'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-culture icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang['CREATE_STAGE'][props.data.languageReducer.userSettings.admin_panel_language],
            onClick: () => props.onChangeStagesHOC('showCreateStages', true),
            display: permissionHandle('is_create')
          }
        ]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeStagesHOC}
                defaultQuery={props.defaultQuery}
                getListAPI={val => props.getStages({
                  ...val,
                  filter: {
                    ...val.filter,
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id
                  }
                })}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.stages}
                  columns={[
                    {
                      Header: Lang['TITLE'][props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: row => (
                        row.original?.title?.[props.data.languageReducer.userSettings.admin_panel_language] ?? '-'
                      )
                    },
                    {
                      Header: Lang['COLOR'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'color',
                      Cell: row => (
                        <div className="d-flex justify-content-center w-100">
                          <div style={{ width: 30, height: 30, background: row.original.color }} />
                        </div>
                      )
                    },
                    {
                      Header: Lang['STATUS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'is_active',
                      Cell: row => (
                        <span>
                          {Lang[!row.original.is_active ? 'ARCHIVE' : 'ACTIVE'][props.data.languageReducer.userSettings.admin_panel_language]}
                        </span>
                      )

                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                  color='primary'
                                  id={`portal-user-${row.original.id}-edit-btn`}
                                  onClick={() => {
                                    props.onChangeStagesHOC('selectedStages', row.original)
                                    props.onChangeStagesHOC('showEditModal', true)
                                  }} >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-edit-btn`}
                                  placement="top">
                                  {Lang['EDIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>
                                <Button
                                  className="mb-2 mt-2 btn-icon btn-icon-only"
                                  color={!row.original.is_active ? 'success' : 'danger'}
                                  onClick={() => {
                                    props.updateStages({
                                      ...row.original,
                                      is_active: !row.original.is_active
                                    })
                                  }}>
                                  {Lang[row.original.is_active ? 'ARCHIVE' : 'ACTIVE'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </Button>
                              </>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.stagesMeta}
                  onChangePage={val => props.getStages({
                    ...props.query,
                    page: val
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {renderCreateStagesForm()}
      {renderUpdateStagesForm()}
      {props.onLoadStagesHOC && <LoadingOverlay />}
    </>
  )
}

export default StagesHOC(Stages)
